// extracted by mini-css-extract-plugin
module.exports = {"root":"Previews-module--root--YTkEH","prev":"Previews-module--prev--31W0s","next":"Previews-module--next--1o7Z0","wrap":"Previews-module--wrap--y3Pzc"};